import { render } from "./Team_post_investment_m.vue?vue&type=template&id=0a8bb4ac&scoped=true"
import script from "./Team_post_investment_m.vue?vue&type=script&lang=js"
export * from "./Team_post_investment_m.vue?vue&type=script&lang=js"

import "./Team_post_investment_m.vue?vue&type=style&index=0&id=0a8bb4ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a8bb4ac"

export default script